export default new Map([
  // dev
  [
    'https://cus-remotesales-dev.linkioapp.com',
    {
      publicOssPrefix: 'dev',
      brandId: '63',
      appid: 'ww35a1377cc1167234',
      agentid: '1000153',
      clientid: '761f806bdab55dc031857aedd04fcad2',
      wechatAppid: 'wxeb13f5b6316ba610',
      wechatClinetid: '0a0343c86225c1f4758514cc1adc0671',
      // interface url
      authUrl: 'https://qa-galassia-openapi.kering.cn/services/dev-cus-api',
      apiUrl: 'https://dev-galassia-cn-api.kering.cn/cus-api/remote-sales/v1',
      etoDomain: 'https://api-suzhou.woaap.com',
      etoAppid: '8ccc27040bc8bc9e6237cc519d73cd5d'
    }
  ],
  // qa
  [
    'https://cus-remotesales-qa.linkioapp.com',
    {
      publicOssPrefix: 'qa',
      brandId: '63',
      appid: 'ww35a1377cc1167234',
      agentid: '1000156',
      clientid: 'b7c9f2b602c9f31d55b978595239d366',
      wechatAppid: 'wxeb13f5b6316ba610',
      wechatClinetid: '2b1a1d5c043315571dd8c3fbc2a0e12d',
      // interface url
      authUrl: 'https://qa-galassia-openapi.kering.cn/services/qa-cus-api',
      apiUrl: 'https://qa-galassia-cn-api.kering.cn/cus-api/remote-sales/v1',
      etoDomain: 'https://api-suzhou.woaap.com',
      etoAppid: '8ccc27040bc8bc9e6237cc519d73cd5d'
    }
  ],
  // preprod brioni
  [
    'https://prp-remotesales.brioni.cn',
    {
      publicOssPrefix: 'preprod',
      // CUS 组织ID
      brandId: '63',
      // 企微 corpId
      appid: 'ww933609f9566c69e1',
      // 企微应用ID
      agentid: '1000012',
      // CUS clientId（wecom）
      clientid: 'ef21d72e5877cf4269caae7aa50ff522',
      // 微信公众号 appid
      wechatAppid: 'wxcada6430d27c41a5',
      // CUS clientId（wechat）
      wechatClinetid: 'c6df19cc84267578802ec246fb612f4b',
      // interface url
      authUrl: 'https://qa-galassia-openapi.kering.cn/services/preprod-cus-api',
      apiUrl:
        'https://preprod-galassia-cn-api.kering.cn/cus-api/remote-sales/v1',
      etoDomain: 'https://api-suzhou.woaap.com',
      etoAppid: '8ccc27040bc8bc9e6237cc519d73cd5d'
    }
  ],
  // preprod BV
  [
    'https://remote-sales-prp.bottegaveneta.cn',
    {
      publicOssPrefix: 'preprod',
      // CUS 组织ID
      brandId: '58',
      // 企微 corpId
      appid: 'ww6b51d307cb47c197',
      // 企微应用ID
      agentid: '1000063',
      // CUS clientId（wecom）
      clientid: 'cf21b8d9a47ee23a29b7bb29b827f99b',
      // 微信公众号 appid
      wechatAppid: "wxf62ebe24f5fb4570",
      // CUS clientId（wechat）
      wechatClinetid: 'ddf8fca5c00969ab845b7796437c2f3b',
      // interface url
      authUrl: 'https://qa-galassia-openapi.kering.cn/services/preprod-cus-api',
      apiUrl:
        'https://preprod-galassia-cn-api.kering.cn/cus-api/remote-sales/v1',
      etoDomain: 'https://api-suzhou.woaap.com',
      etoAppid: 'wxf62ebe24f5fb4570'
    }
  ],
  // preprod BAL
  [
    'https://remote-sales-prp.balenciaga.cn',
    {
      publicOssPrefix: 'preprod',
      // CUS 组织ID
      brandId: '57',
      // 企微 corpId
      appid: 'wwc0daa0b5d68a51f5',
      // 企微应用ID
      agentid: '1000042',
      // CUS clientId（wecom）
      clientid: 'cfeec6d63efcf2214ed98d6b53a7104d',
      // 微信公众号 appid
      wechatAppid: "wxd132b4c0f610918f",
      // CUS clientId（wechat）
      wechatClinetid: 'c834d8b115ba070955f2ecf437b4af7a',
      // interface url
      authUrl: 'https://qa-galassia-openapi.kering.cn/services/preprod-cus-api',
      apiUrl:
        'https://preprod-galassia-cn-api.kering.cn/cus-api/remote-sales/v1',
      etoDomain: 'https://api-suzhou.woaap.com',
      etoAppid: 'wxd132b4c0f610918f'
    }
  ],
  // prod
  [
    'https://remotesales.brioni.cn',
    {
      publicOssPrefix: 'prod',
      brandId: '63',
      appid: 'ww933609f9566c69e1',
      agentid: '1000013',
      clientid: '3d3b950fca483a9d245724430c4d0cb3',
      wechatAppid: 'wxcada6430d27c41a5',
      wechatClinetid: 'b467df8ef33633fbffd38aa9350577b1',
      // interface url
      authUrl: 'https://galassia-openapi.kering.cn/services/cus-api',
      apiUrl: 'https://galassia-cn-api.kering.cn/cus-api/remote-sales/v1',
      etoDomain: 'https://api-suzhou.woaap.com',
      etoAppid: '8ccc27040bc8bc9e6237cc519d73cd5d'
    }
  ],
  // prod BV
  [
    'https://remote-sales.bottegaveneta.cn',
    {
      publicOssPrefix: 'prod',
      brandId: '58',
      appid: 'ww6b51d307cb47c197',
      agentid: '1000005',
      clientid: 'ef6503ca999b6f39f0927611041ffa99',
      wechatAppid: 'wxf62ebe24f5fb4570',
      wechatClinetid: '6e043fae109d9d9b58f8d670bedea489',
      // interface url
      authUrl: 'https://galassia-openapi.kering.cn/services/cus-api',
      apiUrl: 'https://galassia-cn-api.kering.cn/cus-api/remote-sales/v1',
      etoDomain: 'https://api-suzhou.woaap.com',
      etoAppid: 'wxf62ebe24f5fb4570'
    }
  ],
  // prod BAL
  [
    'https://remote-sales.balenciaga.cn',
    {
      publicOssPrefix: 'prod',
      brandId: '57',
      appid: 'wwc0daa0b5d68a51f5',
      agentid: '1000021',
      clientid: '705ab1efd5b3ea6ef1f81561df95ce87',
      wechatAppid: 'wxd132b4c0f610918f',
      wechatClinetid: 'de90dab8d9086571a7b3fb61da24ca11',
      // interface url
      authUrl: 'https://galassia-openapi.kering.cn/services/cus-api',
      apiUrl: 'https://galassia-cn-api.kering.cn/cus-api/remote-sales/v1',
      etoDomain: 'https://api-suzhou.woaap.com',
      etoAppid: 'wxd132b4c0f610918f'
    }
  ]
])
